// La tarjeta que el Brain mete dentro de la conversacion.
//
// Dos cosas la usan y las dos preguntan algo: la operacion que se detuvo a
// confirmar (`ConfirmacionPendiente`, 4.2) y lo que propone recordar de un
// archivo (`FileProposals`, 5.2). Las dos escribian la misma envoltura a mano
// -esquina, borde, icono arriba a la izquierda y el texto sin desbordar-, y el
// presupuesto de cajas lo cazo: la vista `brain` subio a 141 sobre un tope de
// 137 que solo puede bajar.
//
// Y no es solo el recuento. El estandar lo dice en una linea: **lo que aparece
// en dos pantallas se formaliza aqui, o no es una variante**. Escrita dos
// veces, el dia que una cambie de tono la otra se queda con el de antes.
//
// `tone` es lo unico que las separa: avisar de algo irreversible, o solo
// contar. No hay un tercero, y si hace falta se anade aqui.
//
// **No se llama `ConversationCard`**, que era su primer nombre: ya hay una con
// ese nombre exacto en `components/conversations/conversation-card.tsx`, y es
// otra cosa -una fila de la lista de conversaciones-. Dos componentes con el
// mismo nombre en dos ficheros con el mismo nombre se importan mal una vez y
// nadie entiende por que.

import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

const TONES = {
  warning: { box: 'border-warning/40 bg-warning/20', icon: 'text-warning' },
  neutral: { box: 'border-border bg-muted/40', icon: 'text-muted-foreground' },
} as const

export function CalloutCard({
  icon: Icon,
  tone = 'neutral',
  className,
  children,
}: {
  icon: LucideIcon
  tone?: keyof typeof TONES
  className?: string
  children: React.ReactNode
}) {
  const { box, icon } = TONES[tone]
  return (
    <div className={cn('rounded-lg border p-3', box, className)}>
      <div className="flex items-start gap-2">
        <Icon className={cn('mt-0.5 h-4 w-4 shrink-0', icon)} />
        {/* `min-w-0` es lo que impide que un texto largo sin espacios empuje la
            tarjeta fuera del panel, que mide bastante menos que la pantalla. */}
        <div className="min-w-0 flex-1">{children}</div>
      </div>
    </div>
  )
}
